<template>
  <div>
    <v-container v-if="userRecords.length !== 0" class="overflow-y-auto" id="scroll-target">
      <v-card
        v-for="(record, i) in sortArrays(userRecords)"
        :key="i"
        class="mb-2"
        outlined
      >
        <div class="d-flex flex-no-wrap justify-space-between">
          <v-card-text>
            <div class="text-left">
              {{ dispRecordAt(record.recordAt) }}
            </div>
            <h4 class="font-weight-bold mt-3">{{ record.recordContent }}</h4>
            <p class="text-center">{{ record.recordImpresstion }}</p>
          </v-card-text>
        </div>
        <v-card-actions>
          <v-list-item class="grow">
            <v-list-item-avatar>
              <v-img :src="record.recordUser.userPhotoURL"></v-img>
            </v-list-item-avatar>
            <v-list-item-content class="text-left">
              <v-list-item-title>
                {{record.recordUser.userName}}
              </v-list-item-title>
            </v-list-item-content>
            <v-row align="center" justify="end">
              <v-btn icon v-show="!isLiked(record)" @click.stop="createLike(record)">
                <v-icon>{{ "mdi-fire" }}</v-icon>
              </v-btn>
              <v-btn icon v-show="isLiked(record)" @click.stop="deleteLike(record)">
                <v-icon color="orange">{{ "mdi-fire" }}</v-icon>
              </v-btn>
              <v-btn
                @click.stop="toggleLikeModal(record.likeList)"
                small
                text
                min-width="25px"
                class="mr-2 px-0 py-0">
                {{ likeCount(record) }}
              </v-btn>
              <v-btn icon @click.stop="openCommentModal(record)">
                <v-icon>mdi-chat</v-icon>
              </v-btn>
              <v-btn
                @click.stop="openCommentModal(record)"
                small
                text
                min-width="25px"
                class="px-0 py-0">
                {{ commentCount(record) }}
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
      <record-comment-modal-component :record="record" />
      <v-dialog v-model="likeMemberModal" max-width="300px" persistent>
        <v-card class="overflow-y-auto">
          <v-card-title>応援しているユーザー</v-card-title>
          <v-card-text>
            <v-list v-for="(like, i) in likeList" :key="i">
              <v-list-item>
                <v-list-item-avatar>
                  <v-img :src="like.likeUserPhotoURL"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  {{ like.likeUserName }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-text class="text-right">
            <v-btn color="secondary" @click.stop="toggleLikeModal">閉じる</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <v-container v-else>
      <v-card class="mb-2" outlined>
        <div class="d-flex flex-no-wrap justify-space-between">
          <v-card-text>
            <h4 class="text-center">まだユーザーレコードに表示する項目がありません</h4>
            <p class="text-center">ジョブを実施した記録や、グループの活動状況が表示されます</p>
          </v-card-text>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import RecordCommentModalComponent from "../components/RecordCommentModal.vue";
import _ from "lodash";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    RecordCommentModalComponent,
  },
  props: {
    isLoginUser: Boolean
  },
  created(){
    if(!this.isLoginUser) this["record/fetchOtherUserRecords"](this.$route.params.user_id);
  },
  data() {
    return {
      record: {},
      likeList: [],
      likeMemberModal: false,
    };
  },
  computed: {
    ...mapGetters(["loginUserId", "record/myRecords", "record/otherUserRecords", "user/user"]),
    likeCount() {
      return function(record) {
        return record.likeList.length;
      };
    },
    commentCount() {
      return function(record) {
        return record.commentList.length;
      };
    },
    dispRecordAt() {
      return function(recordAt) {
        return moment.unix(recordAt.seconds).format("YYYY-MM-DD HH:mm");
      };
    },
    isLiked() {
      return function(record) {
        return record.likeList.some(like => like.likeUserId === this.loginUserId);
      };
    },
    userRecords() {
      return this.isLoginUser ? this['record/myRecords'] : this["record/otherUserRecords"];
    },
  },

  methods: {
    ...mapActions([
      'record/addLike',
      'record/removeLike',
      "toggleCommentModal",
      "record/fetchOtherUserRecords",
    ]),
    sortArrays(userRecords) {
      userRecords = _.orderBy(userRecords, (record => record.recordAt), 'desc');
      return userRecords;
    },
    createLike(record){
      this['record/addLike'](record.recordId);
    },
    deleteLike(record) {
      const likeId = record.likeList.find(like => like.likeUserId === this.loginUserId).likeId;
      this["record/removeLike"]({ recordId: record.recordId, likeId: likeId });
    },
    openCommentModal(record) {
      this.toggleCommentModal();
      this.record = record;
    },
    toggleLikeModal(likeList) {
      likeList ? (this.likeList = likeList) : (this.likeList = []);
      this.likeMemberModal = !this.likeMemberModal;
    },
  },
};
</script>
